<script setup lang="ts">
import type { EventDto } from "mws-catalog-ts-sdk";

defineProps<{
  event: EventDto;
  isActive?: boolean;
}>();

const getReadableDate = (date: Date) => {
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
</script>

<template>
  <div class="event-list-item__container">
    <span>{{ event.name }}</span>
    <span
      class="event-list-item__dates"
      :class="{ 'event-list-item__dates--active': isActive }"
    >
      {{ getReadableDate(event.startDate) }}
      -
      {{ getReadableDate(event.endDate) }}
    </span>
  </div>
</template>

<style scoped lang="postcss">
.event-list-item {
  &__container {
    @apply flex justify-between py-2;
  }

  &__dates {
    @apply text-gray-400 text-right;

    &--active {
      @apply text-gray-100;
    }
  }
}
</style>
